/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import { Suspense, useEffect, useState } from "react";
import { Redirect, Route, Router } from "react-router-dom";
import { history } from "../helpers";
import * as Layout from "../layout";
import {
  routers,
  routersAgent,
  routersAreaManager,
  routersBusinessDev,
  routersBusinessHead,
  routersClusterManager,
  routersCog,
  routersCogOnboarding,
  routersFinanceTeamMember,
  routersGrainDepositor,
  routersGrainManager,
  routersQualityManager,
  routersSuperAdmin,
  routersSupplier,
  routersUsers,
  routersZonalManager,
} from "./routes";
//import CodeSplitter from "../helpers/CodeSplitter";
import CodeSplitter from "helpers/CodeSplitter";
import { logout } from "service/utilities";

import {
  CommonLoader
} from "component/common/Loader";
import {
  agentData,
  areaManagerData,
  businessDevData,
  businessHeadData,
  clusterManagerData,
  cogData,
  cogOnboardingData,
  financeData,
  grainDepositorData,
  grainManagerData,
  qualityManagerData,
  superAdminData,
  supplierData,
  userData,
  zonalManagerData,
} from "helpers/RoleAccessData";
import { NotificationContainer } from "react-notifications";
import { useDispatch, useSelector } from "react-redux";
import { updatePrevilegesState } from "../redux/reducer/homeSlice";

// import jwtDecode from "jwt-decode";

function Wrapper({ Component, ...props }) {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return <Component {...props} />;
}

const RoutesClass = () => {
  const dispatch = useDispatch();
  const [Routers, setRouters] = useState([]);
  const selectedRole = useSelector((state) => state?.home?.role);
  const privilegesData = useSelector((state) => state?.home?.privileges);
  const profileId = useSelector(state => state.home.userDetails.profileId);
  

  const token = localStorage.getItem("token");
  const mobileNo = localStorage.getItem("mobile");

  useEffect(() => {
    fetchRoutes();
    fetchInitialData();
  }, [selectedRole]);

  const fetchRoutes = async () => {
    const roleDataMappings = {
      CUSTOMER: userData,
      SUPPLIER: supplierData,
      AGENT: agentData,
      BDE: businessDevData,
      "BUSINESS HEAD": businessHeadData,
      "SUPER ADMIN": superAdminData,
      "AREA MANAGER": areaManagerData,
      "COG - COMMERCIAL TEAM - MEMBER": cogData,
      "CLUSTER MANAGER": clusterManagerData,
      "ZONAL MANAGER": zonalManagerData,
      "GRAIN MANAGER": grainManagerData,
      "QUALITY MANAGER": qualityManagerData,
      "GRAIN DEPOSITOR": grainDepositorData,
      "COG - ONBOARDING TEAM - MEMBER": cogOnboardingData,
      "FINANCE - TEAM MEMBER": financeData,
    };

    let role = String(selectedRole).toUpperCase();
    const roleData = roleDataMappings[role];

    if (roleData) {
      dispatch(updatePrevilegesState(roleData));
    } else {
      // Handle the case when role data is not found
      // setRole(userData);
      // dispatch(updatePrevilegesState(userData));
    }
  };

  const fetchInitialData = async () => {
    const roleMappings = {
      CUSTOMER: routersUsers,
      AGENT: routersAgent,
      SUPPLIER: routersSupplier,
      BDE: routersBusinessDev,
      "COG - COMMERCIAL TEAM - MEMBER": routersCog,
      "GRAIN MANAGER": routersGrainManager,
      "QUALITY MANAGER": routersQualityManager,
      "SUPER ADMIN": routersSuperAdmin,
      "AREA MANAGER": routersAreaManager,
      "ZONAL MANAGER": routersZonalManager,
      "BUSINESS HEAD": routersBusinessHead,
      "CLUSTER MANAGER": routersClusterManager,
      "GRAIN DEPOSITOR": routersGrainDepositor,
      "COG - ONBOARDING TEAM - MEMBER": routersCogOnboarding,
      "FINANCE - TEAM MEMBER": routersFinanceTeamMember,
    };

    let role = String(selectedRole).toUpperCase();
    const selectedRouter = roleMappings[role] || routers;
    const currentRoutes = selectedRouter[6]?.childrens;
    setRouters(selectedRouter);
    initialRender(currentRoutes);
  };

  const initialRender = (currentRoutes) => {
    if (
      window.location.pathname === "/auth/login/resetPassword" ||
      window.location.pathname === "/auth/login/ccg-approval" ||
      window.location.pathname === "/auth/login/ccg-approval-agreement" ||
      window.location.pathname === "/success" ||
      window.location.pathname === "/auth/login/addendum" ||
      window.location.pathname === "/auth/terms" ||
      window.location.pathname === "/auth/privacy-policy" ||
      window.location.pathname === "/auth/signup"
    ) {
      return true;
    } else {
      if (!token) {
        history.push("/");
      } else if (token) {
        const isAdminPath = currentRoutes?.some((item) => {
          const pathWithoutAdmin = item?.path.replace("/admin", "");
          return (
            window.location.pathname.startsWith("/admin") &&
            window.location.pathname.includes(pathWithoutAdmin)
          );
        });
        if (isAdminPath) {
          return true;
        } else {
          logout();
        }
        if (selectedRole) {
          if (window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);
            const roleParam = urlParams.get("role");
            const mobile = urlParams.get("mobileNo");
            if (
              window.location.pathname === "/auth/kycdetails" &&
              roleParam &&
              mobile
            ) {
              if (selectedRole === roleParam && mobileNo == mobile) {
                return true;
              } else {
                logout();
              }
            }
          }
        } else {
          logout();
        }
      }
    }
  };

  return (
    <Router history={history}>
      <Suspense fallback={<CommonLoader />} key={Math.random()}>
        {Routers.map(
          ({
            component,
            name,
            componentPath = "",
            redirect,
            path,
            exact = false,
            auth = true,
            childrens = [],
          }) => {
            if (childrens.length > 0) {
              return (
                <Route
                  path={path}
                  exact={exact}
                  key={path + Math.random()}
                  render={(props) => {
                    if (redirect) {
                      if (props.location.pathname == path) {
                        props.history.push(redirect);
                      }
                    }

                    const LayoutComponent = Layout[component];
                    return (
                      <LayoutComponent
                        key={path}
                        {...props}
                        privilegesData={privilegesData}
                      >
                        {childrens.map(
                          ({
                            component: ChildrenComponent,
                            componentPath: childComponentPath,
                            name = "",
                            path: childrenPath,
                            exact = false,
                            auth = true,
                          }) => {
                            CodeSplitter.addComponent(childComponentPath, name);

                            return (
                              <Route
                                path={path + childrenPath}
                                exact={exact}
                                key={path + childrenPath}
                                render={(props) => {
                                  let PageComponent =
                                    CodeSplitter.getComponent(name);
                                  return (
                                    <Wrapper
                                      {...props}
                                      privilegesData={privilegesData}
                                      Component={PageComponent}
                                    />
                                  );
                                }}
                              />
                            );
                          }
                        )}
                      </LayoutComponent>
                    );
                  }}
                />
              );
            }

            CodeSplitter.addComponent(componentPath, name);

            return (
              <Route
                path={path}
                exact={exact}
                key={component + Math.random()}
                render={(props) => {
                  if (component) {
                    let PageComponent = CodeSplitter.getComponent(name);
                    return (
                      <Wrapper
                        {...props}
                        privilegesData={privilegesData}
                        Component={PageComponent}
                      />
                    );
                  }

                  if (redirect) {
                    if (props.location.pathname == path) {
                      return <Redirect to={redirect} />;
                    }
                  }
                  return <div />;
                }}
              />
            );
          }
        )}
        <NotificationContainer />
      </Suspense>
    </Router>
  );
};

// const mapState = (state) => ({
//   privilegesData: state?.home?.privileges,
//   selectedRole: state?.home?.role,
// });

// const mapDispatch = {
//   adminPrivileges: Privileges,
// };

export default RoutesClass;
